import { useMemo, useState } from 'react';
/**
 * State хук, который отслеживает и позволяет изменять булево значение.
 *
 * @param defaultValue Начальное значение, по умолчанию false
 * @returns {ToggleResult}
 */
export function useToggle(defaultValue = false) {
    const [value, setValue] = useState(defaultValue);
    const setters = useMemo(() => ({
        toggleOn: () => setValue(true),
        toggleOff: () => setValue(false),
        toggle: () => setValue(prev => !prev),
    }), []);
    return {
        value,
        setValue,
        ...setters,
    };
}
